import { Quill } from 'vue-quill-editor';
import PlaceholderBlot from './blot';
import PlaceholderModule from './module';
import './icons';
import './scss/placeholder.sass';

Quill.register({
    'formats/placeholder': PlaceholderBlot,
    'modules/placeholder': PlaceholderModule
}, true);

export default { PlaceholderBlot, PlaceholderModule };
